import { hi, kn, te, ta } from "./regional";

export const LANGUAGES = [
  { code: "en", name: "English", native: "English" },
  { code: "hi", name: "Hindi", native: "हिन्दी" },
  { code: "kn", name: "Kannada", native: "ಕನ್ನಡ" },
  { code: "te", name: "Telugu", native: "తెలుగు" },
  { code: "ta", name: "Tamil", native: "தமிழ்" },
  { code: "ml", name: "Malayalam", native: "മലയാളം" },
  { code: "mr", name: "Marathi", native: "मराठी" },
  { code: "bn", name: "Bengali", native: "বাংলা" },
  { code: "gu", name: "Gujarati", native: "ગુજરાતી" },
  { code: "pa", name: "Punjabi", native: "ਪੰਜਾਬੀ" },
  { code: "or", name: "Odia", native: "ଓଡ଼ିଆ" },
  { code: "as", name: "Assamese", native: "অসমীয়া" },
  { code: "ur", name: "Urdu", native: "اردو", dir: "rtl" },
];

const en = {
  "nav.how": "How It Works",
  "nav.experiences": "Experiences",
  "nav.faq": "FAQ",
  "nav.cta": "Discover My Image — ₹99",
  "hero.eyebrow": "An Image Selected From Your Birth Details",
  "hero.title.1": "Discover Your",
  "hero.title.2": "Personalized",
  "hero.title.3": "Divine Image",
  "hero.support":
    "Your name and birth details are unique. SHREE RAGO uses its astrology and numerology-based selection methodology to identify a personalized divine image for your 7-day spiritual experience.",
  "hero.price.line1": "One Personalized Image",
  "hero.price.line2": "Only ₹99",
  "hero.cta": "Discover My Image",
  "hero.trust": "Takes about 2 minutes • Secure Payment • Instant Download",
  "flow.details": "Your Details",
  "flow.analysis": "SHREE RAGO Analysis",
  "flow.image": "Your Image",
  "curiosity.title":
    "Not every image has to feel the same to every person.",
  "curiosity.body":
    "Our names, birth dates, birth times and birth places are different. SHREE RAGO uses these details within its numerology and astrology-based methodology to select an image for your personal spiritual experience.",
  "curiosity.statement.1": "You don't choose the image.",
  "curiosity.statement.2": "Your details guide the selection.",
  "curiosity.cta": "Find My Image — ₹99",
  "how.title": "4 Details. 1 Image. 7 Days.",
  "how.step1.t": "Your Name",
  "how.step1.d": "Enter your full name.",
  "how.step2.t": "Your Birth Details",
  "how.step2.d": "Enter your date, exact time and place of birth.",
  "how.step3.t": "Your Image Is Selected",
  "how.step3.d":
    "SHREE RAGO processes your information using its predefined numerology and astrology-based recommendation system.",
  "how.step4.t": "Download & Experience",
  "how.step4.d":
    "Pay ₹99, download your HD image and set it as your mobile wallpaper for 7 days.",
  "how.cta": "Start My 7-Day Experience",
  "form.title": "Let's discover your image.",
  "form.subtitle": "Enter your birth details below.",
  "form.name": "Full Name",
  "form.name.ph": "Enter your full name",
  "form.dob": "Date of Birth",
  "form.time": "Birth Time",
  "form.unknown": "I don't know my exact birth time",
  "form.place": "Birth Place",
  "form.place.ph": "City, State",
  "form.language": "Preferred Language",
  "form.submit": "Analyze My Details",
  "form.privacy":
    "Your information is used to generate your result and should be handled according to our Privacy Policy.",
  "analysis.1": "Reading your birth details...",
  "analysis.2": "Calculating your numerology...",
  "analysis.3": "Processing your astrology inputs...",
  "analysis.4": "Matching your spiritual image...",
  "analysis.5": "Your SHREE RAGO image has been identified.",
  "locked.ready": "Your Personalized Image Is Ready.",
  "locked.title": "Your Image Is Waiting.",
  "locked.body":
    "Unlock your personalized high-resolution divine image and begin your 7-day experience.",
  "locked.cta": "Unlock My Image — ₹99",
  "locked.trust": "Secure Payment • Instant Access • HD Download",
  "pay.title": "Order Summary",
  "pay.item": "SHREE RAGO — Personalized Divine Image",
  "pay.total": "Total",
  "pay.no_hidden": "No hidden charges.",
  "pay.cta": "Pay ₹99 & Unlock",
  "result.title": "Your SHREE RAGO Image",
  "result.selected_for": "Selected for",
  "result.download": "Download HD Image",
  "result.howto": "How To Use",
  "seven.title": "Your Next 7 Days",
  "seven.i1": "Download your SHREE RAGO image.",
  "seven.i2": "Set it as your mobile lock screen or wallpaper.",
  "seven.i3": "Keep it for the next 7 days.",
  "seven.i4": "Take a moment each day to observe the image mindfully.",
  "seven.i5": "At the end of Day 7, reflect on your personal experience.",
  "seven.motto.1": "7 Days.",
  "seven.motto.2": "One Image.",
  "seven.motto.3": "Your Experience.",
  "seven.cta": "Download My Image",
  "trad.title": "Rooted in Tradition. Delivered Through Technology.",
  "trad.body":
    "India has centuries-old traditions surrounding astrology, numerology, devotional practices and sacred imagery. SHREE RAGO brings inspiration from these traditions into a simple digital experience.",
  "collection.title": "Created with Devotion. Selected for You.",
  "collection.your": "Your image?",
  "collection.cta": "Discover Mine",
  "testimonials.title": "Real People. Real Experiences.",
  "testimonials.more": "View More Experiences",
  "testimonials.coming": "Customer experiences coming soon.",
  "why.title": "A Simple Experience. A Simple Price.",
  "why.body":
    "No subscription. No consultation. No complicated packages. One personalized image. One payment. Instant download. 7-day experience.",
  "why.cta": "Get My Image — ₹99",
  "privacy.title": "Your birth details are personal.",
  "privacy.body":
    "We collect only the information needed to provide the service.",
  "faq.title": "Questions?",
  "final.title": "Your details are unique.",
  "final.sub":
    "Discover the image selected for your 7-day SHREE RAGO experience.",
  "final.cta": "Discover My Image",
  "footer.tagline": "Your Personalized Divine Image",
  "footer.disclaimer":
    "SHREE RAGO provides a spiritual and personal-reflection experience. Astrology and numerology interpretations are belief-based and should not be treated as guaranteed predictions or substitutes for professional advice.",
  "trust.oneprice.t": "One Clear Price",
  "trust.oneprice.d": "₹99. No hidden subscription. No recurring payment.",
  "trust.personal.t": "Your Personal Image",
  "trust.personal.d":
    "Your result is calculated from the birth information you submit and mapped through the SHREE RAGO system.",
  "trust.secure.t": "Secure Payment",
  "trust.secure.d":
    "Payments are processed securely through the configured payment provider.",
  "trust.instant.t": "Instant Access",
  "trust.instant.d":
    "After verified payment, your assigned image becomes available for download.",
  "trust.access.t": "Access Again",
  "trust.access.d":
    "Use your verified mobile number to access your purchased image again.",
  "trust.refund.t": "7-Day Satisfaction Promise",
  "trust.refund.d":
    "Eligible refund requests can be submitted within 7 days according to the published Refund Policy.",
  "trust.privacy.t": "Your Privacy Matters",
  "trust.privacy.d":
    "Birth details and personal information are handled according to the Privacy Policy and are not displayed publicly.",
  "lang.choose": "Choose Your Language",
  "purchase.title": "What You Get for ₹99",
  "purchase.i1": "One Personalized Divine Image",
  "purchase.i2": "High-Resolution Mobile Download",
  "purchase.i3": "Your 7-Day SHREE RAGO Experience",
  "purchase.i4": "Access Again With Your Verified Mobile Number",
  "purchase.i5": "Eligible 7-Day Refund Request",
  "purchase.onetime": "One-Time Payment",
  "purchase.nosubs": "No Subscription",
  "purchase.secure": "🔒 Secure Payment • ₹99 One-Time • 7-Day Refund Policy • HD Download",
  "how.flow.1": "Enter Details",
  "how.flow.2": "Analyze",
  "how.flow.3": "Pay ₹99",
  "how.flow.4": "Download",
  "how.flow.5": "7 Days",
  "form.err.required": "Please fill Name, Date of Birth and Birth Place.",
  "form.err.generic": "Something went wrong. Please try again.",
  "pay.success_demo": "Payment successful (Demo Mode).",
  "pay.failed": "Payment failed. Please try again.",
  "result.setwallpaper": "Set as wallpaper • Observe for 7 days",
  "result.revealing": "✧ Revealing ✧",
  "result.back": "← Back to Home",
  "common.loading": "Loading…",
  "collection.sub": "Premium 9:16 divine artwork, curated across 9 numerology categories.",
  "trust.title": "Why People Trust SHREE RAGO",
  "testimonials.sub": "Authentic reflections from real seekers.",
  "testimonials.verified": "✓ Verified Customer",
  "final.trust": "2 MINUTES • SECURE PAYMENT • INSTANT DOWNLOAD",
  "footer.how": "How It Works",
  "footer.faq": "FAQ",
  "footer.privacy": "Privacy Policy",
  "footer.refund": "Refund & Cancellation",
  "footer.terms": "Terms & Conditions",
  "footer.shipping": "Shipping & Delivery",
  "footer.contact": "Contact",
  "footer.rights": "All rights reserved.",
  "faq.q1": "What is SHREE RAGO?",
  "faq.a1": "SHREE RAGO is a personalized spiritual-image experience that uses the birth details you provide within our numerology and astrology-based selection methodology to identify an image for you.",
  "faq.q2": "What details do I need?",
  "faq.a2": "Your full name, date of birth, birth time and birth place.",
  "faq.q3": "How much does it cost?",
  "faq.a3": "₹99 for one personalized high-resolution digital image.",
  "faq.q4": "What do I receive?",
  "faq.a4": "You receive one personalized divine image that you can download to your mobile.",
  "faq.q5": "How should I use it?",
  "faq.a5": "Set the downloaded image as your mobile wallpaper or lock screen for 7 days and observe your personal experience.",
  "faq.q6": "Will I definitely experience a particular result?",
  "faq.a6": "Individual experiences vary. SHREE RAGO is a spiritual and personal-reflection experience and does not guarantee financial, medical, relationship, career or other specific outcomes.",
  "faq.q7": "Is this medical or financial advice?",
  "faq.a7": "No. SHREE RAGO is not a substitute for professional medical, psychological, financial, legal or other professional advice.",
  "faq.q8": "Can I download it immediately?",
  "faq.a8": "Yes. After successful payment, your image should become available for immediate download.",
  "faq.q9": "Can I share my image?",
  "faq.a9": "The purchased image is licensed for the customer's personal use. Do not expose personal birth information when sharing.",
  "form.mobile": "Mobile Number",
  "form.mobile.ph": "10-digit mobile number",
  "form.mobile.hint": "Used only to send your image and to let you access it again later.",
  "form.err.mobile": "Please enter a valid 10-digit mobile number.",
  "coupon.have": "Have a coupon code?",
  "coupon.label": "Coupon Code",
  "coupon.ph": "ENTER CODE",
  "coupon.apply": "Apply",
  "coupon.remove": "Remove",
  "coupon.applied": "Coupon {code} applied",
  "coupon.invalid": "This coupon code is invalid or has expired.",
  "locked.cta.free": "Unlock My Image — FREE",
  "access.link": "Access my image again",
  "access.eyebrow": "Already purchased?",
  "access.title": "Access Your Image Again",
  "access.body": "Enter the mobile number you used at purchase and your date of birth to re-open and download your divine image.",
  "access.cta": "Find My Image",
  "access.hint": "We match these against your paid order. Nothing is shared publicly.",
  "access.err": "Please enter a valid mobile number and date of birth.",
  "access.notfound": "No paid image found for this mobile number and date of birth.",
  "access.found": "{n} image(s) found",
  "access.open": "Open full page",
  "access.again": "Search another number",
};





const ml = {
  "nav.cta": "എന്റെ ചിത്രം കണ്ടെത്തുക — ₹99",
  "hero.eyebrow": "നിങ്ങളുടെ ജനന വിവരങ്ങളിൽ നിന്ന് തിരഞ്ഞെടുത്ത ചിത്രം",
  "hero.title.1": "കണ്ടെത്തുക",
  "hero.title.2": "വ്യക്തിഗത",
  "hero.title.3": "ദിവ്യ ചിത്രം",
  "hero.cta": "എന്റെ ചിത്രം കണ്ടെത്തുക",
};

const mr = {
  "nav.cta": "माझी प्रतिमा शोधा — ₹99",
  "hero.eyebrow": "तुमच्या जन्मतपशीलांमधून निवडलेली प्रतिमा",
  "hero.title.1": "शोधा तुमची",
  "hero.title.2": "वैयक्तिक",
  "hero.title.3": "दैवी प्रतिमा",
  "hero.cta": "माझी प्रतिमा शोधा",
};

const bn = {
  "nav.cta": "আমার চিত্র আবিষ্কার করুন — ₹99",
  "hero.eyebrow": "আপনার জন্ম বিবরণ থেকে নির্বাচিত একটি ছবি",
  "hero.title.1": "আবিষ্কার করুন আপনার",
  "hero.title.2": "ব্যক্তিগত",
  "hero.title.3": "দিব্য ছবি",
  "hero.cta": "আমার ছবি আবিষ্কার করুন",
};

const gu = {
  "nav.cta": "મારી છબી શોધો — ₹99",
  "hero.eyebrow": "તમારી જન્મ વિગતોમાંથી પસંદ કરેલી છબી",
  "hero.title.1": "શોધો તમારી",
  "hero.title.2": "વ્યક્તિગત",
  "hero.title.3": "દિવ્ય છબી",
  "hero.cta": "મારી છબી શોધો",
};

const pa = {
  "nav.cta": "ਮੇਰੀ ਤਸਵੀਰ ਲੱਭੋ — ₹99",
  "hero.eyebrow": "ਤੁਹਾਡੇ ਜਨਮ ਵੇਰਵਿਆਂ ਤੋਂ ਚੁਣੀ ਗਈ ਤਸਵੀਰ",
  "hero.title.1": "ਲੱਭੋ ਆਪਣੀ",
  "hero.title.2": "ਨਿੱਜੀ",
  "hero.title.3": "ਦੈਵੀ ਤਸਵੀਰ",
  "hero.cta": "ਮੇਰੀ ਤਸਵੀਰ ਲੱਭੋ",
};

const or = {
  "nav.cta": "ମୋର ଛବି ଆବିଷ୍କାର କରନ୍ତୁ — ₹99",
  "hero.eyebrow": "ଆପଣଙ୍କ ଜନ୍ମ ବିବରଣୀରୁ ମନୋନୀତ ଛବି",
  "hero.title.1": "ଆବିଷ୍କାର କରନ୍ତୁ ଆପଣଙ୍କ",
  "hero.title.2": "ବ୍ୟକ୍ତିଗତ",
  "hero.title.3": "ଦିବ୍ୟ ଛବି",
  "hero.cta": "ମୋର ଛବି ଆବିଷ୍କାର କରନ୍ତୁ",
};

const as = {
  "nav.cta": "মোৰ ছবি বিচাৰক — ₹99",
  "hero.eyebrow": "আপোনাৰ জন্মৰ বিৱৰণৰ পৰা বাছি লোৱা ছবি",
  "hero.title.1": "বিচাৰক আপোনাৰ",
  "hero.title.2": "ব্যক্তিগত",
  "hero.title.3": "দিব্য ছবি",
  "hero.cta": "মোৰ ছবি বিচাৰক",
};

const ur = {
  "nav.cta": "میری تصویر دریافت کریں — ₹99",
  "hero.eyebrow": "آپ کی پیدائش کی تفصیلات سے منتخب کردہ تصویر",
  "hero.title.1": "دریافت کریں اپنی",
  "hero.title.2": "ذاتی",
  "hero.title.3": "الہٰی تصویر",
  "hero.cta": "میری تصویر دریافت کریں",
};

export const TRANSLATIONS = {
  en, hi, kn, te, ta, ml, mr, bn, gu, pa, or, as, ur,
};

export function t(lang, key) {
  const dict = TRANSLATIONS[lang] || {};
  if (dict[key]) return dict[key];
  return en[key] || key;
}

export function getLang(code) {
  return LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
}
